import { render, staticRenderFns } from "./DemographicInfo.vue?vue&type=template&id=6ed17f5a&scoped=true"
import script from "./DemographicInfo.vue?vue&type=script&lang=js"
export * from "./DemographicInfo.vue?vue&type=script&lang=js"
import style0 from "./DemographicInfo.vue?vue&type=style&index=0&id=6ed17f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed17f5a",
  null
  
)

export default component.exports